const images = {
    logo: require('./logo.png'),
    glasses: require('./glasses.png'),
    telescope: require('./telescope.png'),
    manRemote: require('./man-remote.png'),
    fallback: require('./fallback.png'),
    posterFallback: require('./poster-placeholder.png'),
    backgroundFallback: require('./fallback-background.png'),
    noResult: require('./noResult.png'),
    avatarPlaceholder: require('./avatar.jpg'),
    starWarHead: require('./starwarHead.png'),
    google: require('./google.png'),
    facebook: require('./facebook.png'),
    profileBackground: require('./profile-background.png'),
};

export default images;
